export const ERROR_PREFIX = "Error: "; // prefix for error messages in redux store (helpful when error message is an empty string)
export const WIDGETS_PAGE_SIZE = 12;
export const READY_STATE = {
  UNSENT: 0, //	Client has been created. open() not called yet.
  OPENED: 1, //	open() has been called.
  HEADERS_RECEIVED: 2, //	send() has been called, and headers and status are available.
  LOADING: 3, //	Downloading; responseText holds partial data.
  DONE: 4 //	The operation is complete.
};
